import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Space, Tooltip, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { supportedSortedMetricsSelector } from '@store/common/selectors';
import MetricDropdown from './MetricDropdown';
import { setGlobalOrderByMetric } from '@store/trends/base/actions';
import { globalOrderBySelector } from '@store/trends/base/selectors';
import { useSupportedMetrics } from '@src/components/common/MetricSelectorPopup/hooks/useSupportedMetrics';
import { StyledTrendSelector } from './styled';

const { Title } = Typography;

const DIMENSION_ORDER_BY_TEXT = 'Order By';

// derived from the diag header component
const TrendSelector = () => {
  const dispatch = useDispatch();
  const orderByMetric = useSelector(globalOrderBySelector);
  const metrics = { ...(useSelector(supportedSortedMetricsSelector) as object) };

  const supportedSortedMetrics = useSupportedMetrics(metrics);

  const applyDimensionSortByMetric = (metric: string) => {
    dispatch(setGlobalOrderByMetric(metric));
  };

  return (
    <StyledTrendSelector>
      <Space size={2} align="baseline">
        <Title level={5} style={{ fontWeight: 400 }}>
          {DIMENSION_ORDER_BY_TEXT}
          <Tooltip title="Displays the top 200 values in order of the selected metric. Use the sort and search feature to rearrange the displayed values.">
            <InfoCircleOutlined style={{ fontSize: 12, verticalAlign: 'super' }} />
          </Tooltip>
        </Title>
        <MetricDropdown
          metrics={supportedSortedMetrics}
          selectedMetric={orderByMetric}
          onChange={applyDimensionSortByMetric}
          size="large"
        />
      </Space>
    </StyledTrendSelector>
  );
};

export default TrendSelector;
